import { AutogenLayoutAgedARReport } from "./autogen/AutogenLayoutAgedARReport";
import { CurrencySettings } from "@mcleod/core";
import {LookupModelSearchEvent, LookupModelSelectionEvent } from "@mcleod/components";

export class AgedARReport extends AutogenLayoutAgedARReport {
    private _userType = "Salesperson"
    private _multicurrencyEnabled = false
    private _isResponsibility = false

    onLoad() {
        this._multicurrencyEnabled = CurrencySettings.get().multicurrency_enabled;
        this.textboxReportBy.selectedItem = this.textboxReportBy.items[0];
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
        this.textboxCallHistory.selectedItem = this.textboxCallHistory.items[0];
        this.setMulticurrencyControls();
    }

    setMulticurrencyControls() {
        if(this._multicurrencyEnabled && !this._isResponsibility) {
            this.textboxCurrency.visible = true
            this.switchGL.visible = true
            this.switchGL.checked = false
            this.textboxCallHistory.captionVisible = false
            this.textboxCallHistory.enabled = false
            this.textboxCallHistory.selectedItem = this.textboxCallHistory.items[0]
        }
        else {
            this.textboxCurrency.visible = false
            this.switchGL.visible = false
            this.textboxCallHistory.captionVisible = true
            this.textboxCallHistory.enabled = true
        }
    }

    switchUserTypeOnChange() {
        const isSalesperson = this.switchUserType.checked
        this._userType = isSalesperson ? "Salesperson" : "Assigned User"
        this.checkboxUserPage.caption = "Page Break After Each " + this._userType
        this.switchGroupBy.rightCaption = this._userType

        this.excludabletextboxA.textbox.clear()
        this.excludabletextboxS.textbox.clear()

        if(isSalesperson) {
            this.excludabletextboxS.visible = true
            this.excludabletextboxA.visible = false
        } else {
            this.excludabletextboxS.visible = false
            this.excludabletextboxA.visible = true
        }
    }

    switchGLOnChange() {
        if(this._multicurrencyEnabled) {
            if(this.switchGL.checked)
                this.textboxCallHistory.enabled = true
            else {
                this.textboxCallHistory.selectedItem = this.textboxCallHistory.items[0]
                this.textboxCallHistory.enabled = false
            }
        }
    }

    switchPastDueOnChange() {
        if(this.switchPastDue.checked) {
            this.switchIncludeOpenCredits.checked = false
            this.switchIncludeOpenCredits.enabled = false
        }
        else {
            this.switchIncludeOpenCredits.enabled = true
        }
    }

    switchGroupByOnChange() {
        if(this.switchGroupBy.checked) {
            this.checkboxUserPage.enabled = true
        }
        else {
            this.checkboxUserPage.checked = false
            this.checkboxUserPage.enabled = false
        }
    }

    textboxReportTypeOnChange() {
        switch(this.textboxReportType.selectedItem?.displayValue) {
            case("Detailed"):
                this.checkboxCustomerPage.enabled = true
                this.switchSortBy.enabled = true
                this.switchPrintBOL.enabled = true
                this.textboxCallHistory.enabled = true
                break;
            case("Summary"):
                this.checkboxCustomerPage.enabled = false
                this.checkboxCustomerPage.checked = false
                this.switchSortBy.enabled = true
                this.switchPrintBOL.enabled = false
                this.switchPrintBOL.checked = false
                this.textboxCallHistory.enabled = false
                this.textboxCallHistory.selectedItem = this.textboxCallHistory.items[0]
                break;
            case("Totals Only"):
                this.checkboxCustomerPage.enabled = false
                this.checkboxCustomerPage.checked = false
                this.switchSortBy.enabled = false
                this.switchPrintBOL.enabled = false
                this.switchPrintBOL.checked = false
                this.textboxCallHistory.enabled = false
                this.textboxCallHistory.selectedItem = this.textboxCallHistory.items[0]
                break;
        }
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "C"
        event.filter.is_active = "Y"
    }
    textboxCategoriesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.customer = "Y"
    }
    textboxAssignedUsersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.web_user_type = "U"
    }
    /** This is an event handler for the onLookupModelSelection event of textboxHierarchyLevel. */
    textboxHierarchyLevelOnLookupModelSelection(event: LookupModelSelectionEvent) {
        this.textboxHierarchyCode.clear();
        this.textboxHierarchyCode.enabled = event.hasSelection();
    }

    /** This is an event handler for the beforeLookupModelSearch event of textboxHierarchyCode. */
    textboxHierarchyCodeBeforeLookupModelSearch(event) {
        event.filter.hierarchy_level = this.textboxHierarchyLevel.lookupModelData[0].get("level_number");
    }

    public set isResponsibility(value: boolean) {
        this._isResponsibility = value;
        this.textboxHierarchyCode.visible = this.textboxHierarchyLevel.visible = this.textboxHierarchyGroupBy.visible = this._isResponsibility;
        this.checkboxCustomerPage.visible = !this._isResponsibility;
        this.sourceAgedAR.url = this._isResponsibility ? "lme/ar/reports/aged-ar-responsibility" : "lme/ar/reports/aged-ar"
        this.setMulticurrencyControls();
    }
}
